import React from "react";

class ChatErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ChatBot error boundary caught:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 bg-amber-50 text-amber-900 rounded-2xl border border-amber-200 shadow-lg text-sm max-w-xs">
          <p className="font-semibold mb-1">Chat assistant encountered an issue.</p>
          <p className="text-xs text-amber-700 mb-3">Please click reset to restart the conversation.</p>
          <button
            onClick={this.handleReset}
            className="px-3 py-1.5 bg-orange-600 text-white rounded-lg text-xs font-medium hover:bg-orange-700 transition shadow-sm"
          >
            Reset Chat
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ChatErrorBoundary;
